// extracted by mini-css-extract-plugin
module.exports = {"container":"_d9a5edc","header":"_bb02a14","title":"_ce91de3","buttons":"_b830b8c","button":"_59a16b4","right":"_b27686f","slider":"_ab1a18c"};